import React, { useEffect, useContext, useState } from "react"
import "./index.css"
import { NAME_SERVER } from "../../../Utils/NAME_HOST";
import Timer from "../Timer/Timer";
import { observer } from "mobx-react-lite";
import { Context } from "../../../index";
import formatCurrency from "../../../Utils/formatCurrency";
function TableBets({ props, closeModal }) {
    const { store } = useContext(Context)
    const [infoKoef, setInfoKoef] = useState(null);
    useEffect(() => {
        const nums = document.querySelectorAll(".num")
        const reds = document.querySelectorAll(".black")
        let red_massive = [];
        for (let red of reds) {
            red_massive.push(red.textContent)
        }

        for (let num of nums) {
            const number = Number(num.textContent)
            if (number >= 1 && number <= 12) {
                num.rad = "1st 12"
                num.setAttribute("rad", "1st 12")
                // num.classList.add("1st 12")

            }
            if (number >= 13 && number <= 24) {
                num.rad = "2nd 12"
                num.setAttribute("rad", "2nd 12")
                // num.classList.add("2nd 12")

            }
            if (number >= 25 && number <= 36) {
                num.rad = "3rd 12"
                num.setAttribute("rad", "3rd 12")
                // num.classList.add("3rd 12")

            }
            if (number >= 1 && number <= 18) {
                num.setAttribute("part", "1")
            }
            else {
                num.setAttribute("part", "2")

            }
            if (number % 2 == 0) {
                num.classList.add("EVEN")
            }
            else {
                num.classList.add("ODD")
            }

        }
    }, []);
    const numbers = {
        "1": [3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36],
        "2": [2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32, 35],
        "3": [1, 4, 7, 10, 13, 16, 19, 22, 25, 28, 31, 34]
    }
    function hover_by_color(color) {
        if (!props.game_status) {


            const elems = document.querySelectorAll(".num." + color)
            for (let el of elems) {
                el.classList.add("hover")

            }
        }
    }
    function unhover_by_color(color) {
        if (!props.game_status) {
            const elems = document.querySelectorAll(".num." + color);
            for (let el of elems) {
                el.classList.remove("hover"); // Удаление класса "hover"

            }
        }
    }
    function hover_by_sector(sector) {
        setInfoKoef(3);

        const elems = document.querySelectorAll(`tr[sector="${sector}"] .num`);

        for (let elem of elems) {
            elem.classList.add("hover")
        }
    }
    function hover_other_elemnt(name, attribute) {
        let elems = null;

        if (attribute === "class") {
            elems = document.querySelectorAll(".num." + name)

        }
        else {
            elems = document.querySelectorAll(`.num[${attribute}="${name}"]`);


        }
        for (let elem of elems) {
            elem.classList.add("hover")
        }
    }
    function unhover_other_elemnt(name, attribute) {
        let elems = null
        if (attribute === "class") {
            elems = document.querySelectorAll(".num." + name)

        }
        else {
            elems = document.querySelectorAll(`.num[${attribute}="${name}"]`);

        }
        for (let el of elems) {
            el.classList.remove("hover"); // Удаление класса "hover"

        }
    }
    function unhover_by_sector(sector) {
        const elems = document.querySelectorAll(`tr[sector="${sector}"] .num`);

        for (let elem of elems) {
            elem.classList.remove("hover")
        }
    }

    function setChoice_bet(bet, state = null) {
        closeModal();
        setInfoKoef(null);


        store.setChoice_betRoulete(bet)


    }
    useEffect(() => {
        if (props.game_status) {
            closeModal();
            
            setInfoKoef(null);

        }
    }, [props.game_status])

    return (
        <div className="roulette">
            {infoKoef && <div className="infoKoefsRoulette skeleton-button">
                <div>X{infoKoef}</div><div>Вы получите <span style={{color:"greenyellow"}}>{formatCurrency(props.amount*infoKoef,"cost")}</span></div></div>}
            <div className="table-wrapper">

                <table className={props.game_status ? "rotate" : "unrotate"} id="tableBets">
                    <tr className="nums" sector="1">
                        <td className="num zero" onClick={(e) => setChoice_bet("green", true)}>
                            <div className="img-container" onMouseEnter={() => setInfoKoef(36)}>

                                <img className="imgChoice" src={NAME_SERVER + "/assets/" + "greenx" + ".png"} />
                            </div>
                        </td>

                        <td className="num red" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(3)}><span>3</span></td>
                        <td className="num black" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(6)}><span>6</span></td>
                        <td className="num red" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(9)}><span>9</span></td>
                        <td className="num red" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(12)}><span>12</span></td>
                        <td className="num black" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(15)}><span>15</span></td>
                        <td className="num red" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(18)}><span>18</span></td>
                        <td className="num red" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(21)}><span>21</span></td>
                        <td className="num black" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(24)}><span>24</span></td>
                        <td className="num red" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(27)}><span>27</span></td>
                        <td className="num red" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(30)}><span>30</span></td>
                        <td className="num black" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(33)}><span>33</span></td>
                        <td className="num red" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(36)}><span>36</span></td>
                        <td className="sector" data-sector="1" onClick={(e) => setChoice_bet("2 to 1")} onMouseEnter={() => hover_by_sector("1")} onMouseLeave={() => unhover_by_sector("1")}><span className="vt">2 to 1</span></td>
                    </tr>
                    <tr className="nums" sector="2">
                        <td className="empty"></td>

                        <td className="num black" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(2)}><span>2</span></td>
                        <td className="num red" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(5)}><span>5</span></td>
                        <td className="num black" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(8)}><span>8</span></td>
                        <td className="num black" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(Number(e.target.textContent))}><span>11</span></td>
                        <td className="num red" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(Number(e.target.textContent))}><span>14</span></td>
                        <td className="num black" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(Number(e.target.textContent))}><span>17</span></td>
                        <td className="num black" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(Number(e.target.textContent))}><span>20</span></td>
                        <td className="num red" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(Number(e.target.textContent))}><span>23</span></td>
                        <td className="num black" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(Number(e.target.textContent))}><span>26</span></td>
                        <td className="num black" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(Number(e.target.textContent))}><span>29</span></td>
                        <td className="num red" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(Number(e.target.textContent))}><span>32</span></td>
                        <td className="num black" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(Number(e.target.textContent))}><span>35</span></td>
                        <td className="sector" onClick={(e) => setChoice_bet("2 to 2")} onMouseEnter={() => hover_by_sector("2")} onMouseLeave={() => unhover_by_sector("2")} data-sector="2"><span className="vt">2 to 1</span></td>
                    </tr>
                    <tr className="nums" sector="3">
                        <td className="num zero" onClick={(e) => setChoice_bet("gold")}>
                            <div className="img-container" onMouseEnter={() => setInfoKoef(36)}>
                                <img className="imgChoice"
                                    src={NAME_SERVER + "/assets/" + "goldx" + ".png"} />
                            </div>
                        </td>
                        <td className="num red" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(Number(e.target.textContent))}><span>1</span></td>
                        <td className="num black" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(Number(e.target.textContent))}><span>4</span></td>
                        <td className="num red" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(Number(e.target.textContent))}><span>7</span></td>
                        <td className="num black" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(Number(e.target.textContent))}><span>10</span></td>
                        <td className="num black" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(Number(e.target.textContent))}><span>13</span></td>
                        <td className="num red" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(Number(e.target.textContent))}><span>16</span></td>
                        <td className="num red" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(Number(e.target.textContent))}><span>19</span></td>
                        <td className="num black" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(Number(e.target.textContent))}><span>22</span></td>
                        <td className="num red" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(Number(e.target.textContent))}><span>25</span></td>
                        <td className="num black" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(Number(e.target.textContent))}><span>28</span></td>
                        <td className="num black" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(Number(e.target.textContent))}><span>31</span></td>
                        <td className="num red" onMouseEnter={() => setInfoKoef(36)} onClick={(e) => setChoice_bet(Number(e.target.textContent))}><span>34</span></td>
                        <td className="sector" data-sector="3" onClick={(e) => setChoice_bet("2 to 3")} onMouseEnter={() => hover_by_sector("3")} onMouseLeave={() => unhover_by_sector("3")}><span className="vt">2 to 1</span></td>
                    </tr>
                    <tr style={{ borderBottom: 0 }}>
                        <td className="empty"></td>
                        <td colSpan="4" className="sector" data-sector="4" onClick={(e) => setChoice_bet(e.target.textContent)} onMouseEnter={(e) => { hover_other_elemnt(e.target.textContent, "rad"); setInfoKoef(3) }} onMouseLeave={(e) => unhover_other_elemnt(e.target.textContent, "rad")}><span>1st 12</span></td>
                        <td colSpan="4" className="sector" data-sector="5" onClick={(e) => setChoice_bet(e.target.textContent)} onMouseEnter={(e) => { hover_other_elemnt(e.target.textContent, "rad"); setInfoKoef(3) }} onMouseLeave={(e) => unhover_other_elemnt(e.target.textContent, "rad")}><span>2nd 12</span></td>
                        <td colSpan="4" className="sector" data-sector="6" onClick={(e) => setChoice_bet(e.target.textContent)} onMouseEnter={(e) => { hover_other_elemnt(e.target.textContent, "rad"); setInfoKoef(3) }} onMouseLeave={(e) => unhover_other_elemnt(e.target.textContent, "rad")}><span>3rd 12</span></td>
                        <td className="empty"></td>
                    </tr>
                    <tr style={{ borderBottom: 0 }} onMouseEnter={() => setInfoKoef(2)}>
                        <td className="empty"></td>
                        <td colSpan="2" className="sector" data-sector="7" onClick={(e) => setChoice_bet(e.target.textContent)} onMouseEnter={(e) => hover_other_elemnt("1", "part")} onMouseLeave={(e) => unhover_other_elemnt("1", "part")}><span>1 to 18</span></td>
                        <td colSpan="2" className="sector" data-sector="8" onClick={(e) => setChoice_bet(e.target.textContent)} onMouseEnter={(e) => hover_other_elemnt(e.target.textContent, "class")} onMouseLeave={(e) => unhover_other_elemnt(e.target.textContent, "class")}><span>EVEN</span></td>
                        <td colSpan="2" className="sector" data-sector="9" onClick={(e) => setChoice_bet("red", true)} onMouseLeave={() => unhover_by_color("red")} onMouseEnter={() => hover_by_color("red")}><div className="img-container"><img className="imgChoice" src={NAME_SERVER + "/assets/" + "redx" + ".png"} /></div></td>
                        <td colSpan="2" className="sector" data-sector="10" onClick={(e) => setChoice_bet("blue", true)} onMouseLeave={() => unhover_by_color("black")} onMouseEnter={() => hover_by_color("black")}><div className="img-container"><img className="imgChoice" src={NAME_SERVER + "/assets/" + "bluex" + ".png"} /></div></td>
                        <td colSpan="2" className="sector" data-sector="11" onClick={(e) => setChoice_bet(e.target.textContent)} onMouseEnter={(e) => hover_other_elemnt(e.target.textContent, "class")} onMouseLeave={(e) => unhover_other_elemnt(e.target.textContent, "class")}><span>ODD</span></td>
                        <td colSpan="2" className="sector" data-sector="12" onClick={(e) => setChoice_bet(e.target.textContent)} onMouseEnter={(e) => hover_other_elemnt("2", "part")} onMouseLeave={(e) => unhover_other_elemnt("2", "part")}><span>19 to 36</span></td>
                        <td className="empty"></td>
                    </tr>
                </table>
            </div>

        </div>
    )
}
export default observer(TableBets)